module.exports = __webpack_public_path__ + "static/invite-finger.e3bfbd90.png";